import { ShieldCheck, FlaskConical, BadgeCheck, Microscope, MapPin } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "FSSAI" },
  { icon: FlaskConical, label: "Bio-Absorb Matrix" },
  { icon: BadgeCheck, label: "Effective Doses" },
  { icon: Microscope, label: "Third-Party Tested" },
  { icon: MapPin, label: "Made in India · GMP" },
];

export function TrustBar({ className = "" }: { className?: string }) {
  // One pass per track; the second (aria-hidden) track completes the loop.
  const loop = ITEMS;

  return (
    <section
      aria-label="Trust signals"
      className={`relative overflow-hidden bg-brand text-white ${className}`}
    >
      <div className="group flex w-full overflow-hidden py-2.5">
        <ul
          className="flex shrink-0 items-center gap-8 pr-8 animate-marquee whitespace-nowrap motion-reduce:animate-none"
          aria-hidden="false"
        >
          {loop.map(({ icon: Icon, label }, i) => (
            <li
              key={`${label}-${i}`}
              className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-white"
            >
              <Icon className="h-3.5 w-3.5 shrink-0 text-white/90" aria-hidden />
              <span>{label}</span>
            </li>
          ))}
        </ul>
        <ul
          className="flex shrink-0 items-center gap-8 pr-8 animate-marquee whitespace-nowrap motion-reduce:animate-none"
          aria-hidden="true"
        >
          {loop.map(({ icon: Icon, label }, i) => (
            <li
              key={`dup-${label}-${i}`}
              className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-white"
            >
              <Icon className="h-3.5 w-3.5 shrink-0 text-white/90" aria-hidden />
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
